import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ov = {
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 },
  modal: { background: "#fff", borderRadius: 14, padding: 26, width: "100%", maxWidth: 440, boxShadow: "0 10px 40px rgba(0,0,0,0.2)", maxHeight: "90vh", overflowY: "auto" },
  title: { margin: 0, fontSize: 18, fontWeight: 700, color: "#222" },
  sub: { margin: "4px 0 18px", fontSize: 13, color: "#888" },
  label: { display: "block", fontSize: 12, fontWeight: 700, color: "#666", marginBottom: 5, marginTop: 14, textTransform: "uppercase", letterSpacing: "0.04em" },
  input: { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 14, outline: "none", color: "#222", boxSizing: "border-box" },
  row: { display: "flex", gap: 14, alignItems: "center", marginTop: 14 },
  checkRow: { display: "flex", alignItems: "center", gap: 8, marginTop: 16, cursor: "pointer" },
  btnRow: { display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 24 },
  btnCancel: { padding: "9px 18px", background: "#fff", color: "#888", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer" },
  btnSave: { padding: "9px 20px", background: "#9f0059", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: "pointer" },
};

// usuario: objeto para editar (null = crear). onSaved/onClose.
const UsuarioModal = ({ usuario, onClose, onSaved }) => {
  const esEdicion = !!usuario;

  const [nombre,    setNombre]    = useState(usuario?.nombre  || "");
  const [mail,      setMail]      = useState(usuario?.mail    || "");
  const [empresa,   setEmpresa]   = useState(usuario?.empresa || "");
  const [password,  setPassword]  = useState("");
  const [tipo,      setTipo]      = useState(usuario?.tipo_id ? Number(usuario.tipo_id) : 2);
  const [comercial, setComercial] = useState(usuario ? Number(usuario.comercial) === 1 : false);
  const [saving,    setSaving]    = useState(false);

  const guardar = async () => {
    if (!nombre.trim() || !mail.trim()) { toast.error("Nombre y email son obligatorios."); return; }
    if (!esEdicion && !password.trim()) { toast.error("Poné una contraseña."); return; }
    setSaving(true);
    try {
      let r;
      if (esEdicion) {
        const fd = new URLSearchParams({ id: usuario.id, nombre: nombre.trim(), mail: mail.trim(), empresa: empresa.trim() });
        if (password.trim()) fd.append("password", password.trim());
        r = await axios.post(`${BASE}/usuarios_editar.php`, fd);
      } else {
        r = await axios.post(`${BASE}/usuarios_crear.php`, new URLSearchParams({
          nombre: nombre.trim(), mail: mail.trim(), empresa: empresa.trim(),
          password: password.trim(), tipo, comercial: comercial ? 1 : 0, activo: 1,
        }));
      }
      if (r.data?.success) {
        toast.success(esEdicion ? "Usuario actualizado" : "Usuario creado");
        onSaved && onSaved();
      } else {
        toast.error(r.data?.mensaje || "Error al guardar");
      }
    } catch { toast.error("Error de conexión"); }
    finally  { setSaving(false); }
  };

  return (
    <div style={ov.overlay} onClick={onClose}>
      <div style={ov.modal} onClick={(e) => e.stopPropagation()}>
        <p style={ov.title}>{esEdicion ? "Editar usuario" : "Nuevo usuario"}</p>
        <p style={ov.sub}>{esEdicion ? "Modificá los datos del usuario." : "Creá un usuario nuevo con acceso al sistema."}</p>

        <label style={ov.label}>Nombre *</label>
        <input style={ov.input} value={nombre} onChange={(e) => setNombre(e.target.value)} autoFocus />

        <label style={ov.label}>Email *</label>
        <input style={ov.input} type="email" value={mail} onChange={(e) => setMail(e.target.value)} />

        <label style={ov.label}>Empresa</label>
        <input style={ov.input} value={empresa} onChange={(e) => setEmpresa(e.target.value)} />

        <label style={ov.label}>{esEdicion ? "Nueva contraseña (dejar vacío para no cambiar)" : "Contraseña *"}</label>
        <input style={ov.input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={esEdicion ? "••••••" : ""} />

        {/* Rol y comercial solo al crear; en edición se manejan inline en la tabla */}
        {!esEdicion && (
          <>
            <label style={ov.label}>Rol</label>
            <select style={ov.input} value={tipo} onChange={(e) => setTipo(Number(e.target.value))}>
              <option value={1}>Administrador</option>
              <option value={2}>Usuario</option>
              <option value={3}>Proveedor</option>
            </select>
            <label style={ov.checkRow}>
              <input type="checkbox" checked={comercial} onChange={(e) => setComercial(e.target.checked)} style={{ width: 17, height: 17, accentColor: "#9f0059" }} />
              <span style={{ fontSize: 14, color: "#444" }}>Es comercial (aparece en comisiones)</span>
            </label>
          </>
        )}

        <div style={ov.btnRow}>
          <button style={ov.btnCancel} onClick={onClose} disabled={saving}>Cancelar</button>
          <button style={{ ...ov.btnSave, opacity: saving ? 0.6 : 1 }} onClick={guardar} disabled={saving}>
            {saving ? "Guardando…" : "Guardar"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UsuarioModal;
